import { HomeHeartIcon } from './HomeHeartIcon';

/**
 * author: Google
 * id 513D2CF1-31F5-4F3B-8543-2499ABB20924
 * name home-heart
 * version: 2.1.19
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-heart.svg
 * tags
 * - Home Automation 
 * - People / Family 
 */
export const HouseHeartIcon = HomeHeartIcon;
export default HouseHeartIcon